<br>

<p-panel>
  @if (!formReady) {
    <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
      <p-progressSpinner
        strokeWidth="4"
        [style]="{width: '60px', height: '60px'}"
        animationDuration=".8s">
      </p-progressSpinner>
    </div>
  }

  @if (formReady) {
    <app-reactive-form-builder
      (formChanges)="formChanges($event[0], $event[1])"
      (internalLifecycleEvents)="onInternalLifecycleEvent($event)"
      (goBack)="goBack()"
      (afterSend)="afterSend()"
      [form]="form.formFields"
      [dropdownLoadTrigger]="dropdownLoadTrigger"
      [id]="getModel().id ?? ''"
      [request]="this.getType() === 1 ? this.tareasApi.otras.PUT : this.tareasApi.otras.POST"
      [getRequest]="tareasApi.otras.GET">
    </app-reactive-form-builder>

    <div class="row">
      <div class="col-md-6">
        <app-dictado *ngIf="this.appName === 'ava'"
          mensaje="Grabar observaciones"
          [observaciones]="model.observaciones ?? ''"
          (sendObservaciones)="getObservaciones($event)">
        </app-dictado>
      </div>
    </div>
    <br>
    @if ((this.appName === 'tomega' && this.rolUser !== 'aplicador') || this.appName !== 'tomega') {
      <p>TRABAJADORES SELECCIONADOS: {{seleccionados}}</p>
    }
  }
</p-panel>
<br>
<p-toast styleClass="custom-toast" [style]="{'zIndex': '1010'}"></p-toast>
